var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.breadcrumbs)?_c('v-layout',{staticClass:"align-center layout px-4 pt-4 app--page-header",attrs:{"row":""}},[_c('v-breadcrumbs',{attrs:{"divider":"-","items":_vm.breadcrumbs}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }